import { Box, Button, CircularProgress, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getDistributors,
  getDistributorsResponse,
  SubDistributor,
} from '../../redux-store/actions';
import React, { useEffect, useMemo, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  POA_Authorized_signatory_can_Esign_Enable,
  POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE,
  poaValidationDate,
  // RMEmailIdFieldValidationDate,
  RMNameAndMobileFieldValidationDate,
  USER_ROLES,
  subdistributorTypes,
} from '../../utils/constant';
import { InfoDialog, Notes, SubHeading } from './components';
import UseRadioGroup from '../../lib/formik/Radio';
import { distributorsValidationSchema } from '../../utils/schema';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  allowOnlyNumbers,
  applicationComparison,
  applyRoleBasedStatus,
  checkIfApplicationIsIndividualPOA,
  checkValidationBasedOnDate,
  checkIfDistributorIndividual,
  checkSubDisDisable,
  checkSupportLogin,
} from '../../utils/utilityFunctions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { ConfirmationDialog } from '../commonComponents';
import {
  DistributorListType,
  POAAuthorisedSignatories,
  SubDistributorListType,
  SupportRmProp,
} from '../../redux-store/types/api-types';
import { getDistributorById, getDistributorRMbyId } from '../../redux-store/actions/userManagement';
import { getDirectApplicableFunds } from '../../redux-store/actions/funds';
import { FundProps } from '../../redux-store/types/funds';
import { POAAuthorisedSignatoriesFragment } from '../NonIndividualInvestor/Authorised';

type DistributorDetailsProps = {
  distributorName: string | null;
  distributorId: number | null;
  distributorEmail: string | null;
  distributorNumber: string | null;
  distributorType: string;
  loginType: string;
  firstName: string;
  empCode: string;
  email: string;
  mobile: string;
  subdistributorId: number | null;
  subdistributorName: string | null;
  subdistributorEmail: string | null;
  distMangementFee: string | null;
  distPerformanceFee: string | null;
  subdistributorPhone: string | null;
  supportDistributorEmail: string | null;
  supportDistributorPhone: string | null;
  supportSubdistributorId: string | null | number;
  filledBy: string | null;
  rmEmailId: string | null;
  rmName: string | null;
  rmMobile: string | null;
  rmEmail: string | null;
};

type POAApplication = {
  authorisedSignatories: POAAuthorisedSignatories[];
  thrashold: number;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} sm={6}>
      {children}
    </Grid>
  );
}

function AdditionalRMEMailID(): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <GridItem>
      <MFTextField
        name="rmEmailId"
        label={`Additional RM Email Id`}
        placeholder="Enter Additional RM Email Id"
        disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
      />
    </GridItem>
  );
}

const RMDetail = () => {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const { application } = useSelector((store: RootStateType) => store.application);
  return (
    <>
      <GridItem>
        <MFTextField
          name="firstName"
          label="Maker Name"
          placeholder="Enter Maker name"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="email"
          label="Maker Email ID"
          placeholder="Enter Maker Email ID"
          disabled={true}
        />
      </GridItem>
      {/* <GridItem>
        <MFTextField
          name="empCode"
          label="Employee Code"
          placeholder="Enter Employee Code"
          disabled={true}
        />
      </GridItem> */}
      <GridItem>
        <MFTextField
          name="rmName"
          label={`RM Name${
            checkValidationBasedOnDate(
              application?.createdAt || '',
              RMNameAndMobileFieldValidationDate
            )
              ? ' *'
              : ''
          }`}
          placeholder="Enter RM Name"
          disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="rmMobile"
          label={`RM Mobile No${
            checkValidationBasedOnDate(
              application?.createdAt || '',
              RMNameAndMobileFieldValidationDate
            )
              ? ' *'
              : ''
          }`}
          placeholder="Enter RM Mobile No"
          disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
        />
      </GridItem>

      <GridItem>
        <MFTextField
          name="rmEmail"
          label={`RM Email Id ${
            checkValidationBasedOnDate(
              application?.createdAt || '',
              RMNameAndMobileFieldValidationDate
            )
              ? ' *'
              : ''
          }`}
          placeholder="Enter RM Email Id"
          disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
        />
      </GridItem>
      <AdditionalRMEMailID />
    </>
  );
};

const DistributorDetail = ({
  distributors,
  values,
  selectedDistributor,
  setSelectedDistributor,
  authorisedSignatoriesPOA,
  setAuthorisedSignatoriesPOA,
  selectSupport,
  setSelectSupport,
}: {
  distributors: Distributor[];
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  setSelectedDistributor: (distributor: SubDistributor[]) => void;
  authorisedSignatoriesPOA: POAApplication;
  setAuthorisedSignatoriesPOA: (e: POAApplication) => void;
  selectSupport: SupportRmProp[];
  setSelectSupport: (distributor: SupportRmProp[]) => void;
}): JSX.Element => {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { setValues } = useFormikContext();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { auth } = useSelector((store: RootStateType) => store);
  const [openDialog, setDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogOpen = () => {
    setDialog(true);
  };
  const handleDialogClose = () => {
    setDialog(false);
  };

  return (
    <>
      {distributors.length > 0 ? (
        <>
          {[USER_ROLES.RM].includes(role) && values.distributorId && (
            <Grid item xs={12} sx={{ textAlign: 'right' }}>
              <Button
                variant="contained"
                sx={{
                  color: 'white',
                  fontWeight: 500,
                  fontSize: 14,
                  py: 0.5,
                  px: 3,
                }}
                onClick={handleDialogOpen}>
                clear
              </Button>
            </Grid>
          )}
          <GridItem>
            <SearchableSelect
              name="distributorId"
              label="Distributor Code *"
              items={distributors
                .sort((distributor1, distributor2) =>
                  (distributor1['name'] || '')
                    .toString()
                    .localeCompare((distributor2['name'] || '').toString())
                )
                .map((item) => ({
                  key: (item.name || 'NA') + ' - ' + (item.arnCode || 'NA'),
                  value: item.id,
                }))}
              onChange={({ target: { value } }) => {
                const distributorCode = distributors.find((item) => item.id === value);
                const { id = null, name, type, user } = distributorCode || {};
                setValues({
                  ...values,
                  distributorName: name,
                  distributorId: id,
                  distributorType: type,
                  distributorEmail: checkIfDistributorIndividual(type || '') ? user?.email : null,
                  distributorNumber: checkIfDistributorIndividual(type || '') ? user?.phone : null,
                  subdistributorId: null,
                  subdistributorName: null,
                  subdistributorEmail: null,
                  subdistributorPhone: '',
                  supportDistributorEmail: '',
                  supportDistributorPhone: '',
                  supportSubdistributorId: null,
                });
                setSelectedDistributor(
                  distributors
                    ?.find((distributor) => distributor.id === value)
                    ?.subdistributors?.filter(
                      (ele) =>
                        subdistributorTypes[ele.subdistributorType || ''] ===
                        subdistributorTypes.direct
                    ) || []
                );
              }}
              disabled={[
                USER_ROLES.DISTRIBUTOR,
                USER_ROLES.INVESTOR,
                USER_ROLES.POAAPPROVER,
                USER_ROLES.SUBDISTRIBUTOR,
              ].includes(role)}
              applyRenderValue={true}
              searchFieldPlaceholder={'Search Distributor'}
            />
            {loading && (
              <Box sx={{ display: 'flex' }}>
                <CircularProgress size={30} />
              </Box>
            )}
          </GridItem>
          <GridItem>
            <MFTextField
              name="distributorName"
              label="Distributor Name *"
              placeholder="Enter Distributor name"
              disabled={true}
            />
          </GridItem>
          {checkIfDistributorIndividual(values.distributorType || '') && (
            <>
              <GridItem>
                <MFTextField
                  name="distributorEmail"
                  label="Distributor Email *"
                  placeholder="Enter Distributor email"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="distributorNumber"
                  label="Distributor Mobile Number"
                  placeholder="Enter Distributor Mobile Number"
                  disabled={true}
                />
              </GridItem>
            </>
          )}
          {!!selectedDistributor?.length && (
            <>
              <GridItem>
                <SearchableSelect
                  name="subdistributorId"
                  label="Distributor Sales RM Name - Code *"
                  items={selectedDistributor
                    .sort((subDistributor1, subDistributor2) =>
                      (subDistributor1.user['firstName'] || '')
                        .toString()
                        .localeCompare((subDistributor2.user['firstName'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.user.firstName + ' - ' + (item.distributors_RM_Code || 'NA'),
                      value: item.id,
                    }))}
                  onChange={async ({ target: { value } }) => {
                    try {
                      setLoading(true);
                      const getDistributorRmDetails = (await dispatch(
                        getDistributorRMbyId(Number(value))
                      )) as unknown as SubDistributorListType;
                      setSelectSupport(
                        (getDistributorRmDetails?.supportSubdistributorDetails
                          ?.supportSubdistributor as unknown as SupportRmProp[]) || []
                      );
                      const {
                        id = null,
                        user,
                        supportSubdistributorId = null,
                        supportSubdistributorDetails,
                      } = getDistributorRmDetails || {};
                      const { supportSubdistributor = [] } = supportSubdistributorDetails || {};
                      const { email, phone } = user || {};
                      setValues({
                        ...values,
                        subdistributorId: id,
                        subdistributorEmail: email || '',
                        subdistributorPhone: phone || '',
                        supportDistributorEmail:
                          application?.supportSubdistributor &&
                          !checkSupportLogin(
                            Number(auth.id),
                            Number(application?.supportSubdistributor?.user.id)
                          )
                            ? supportSubdistributor?.length
                              ? supportSubdistributor[0]?.user?.email
                              : ''
                            : application?.supportSubdistributor?.user.email || '',
                        supportDistributorPhone:
                          application?.supportSubdistributor &&
                          !checkSupportLogin(
                            Number(auth.id),
                            Number(application?.supportSubdistributor?.user.id)
                          )
                            ? supportSubdistributor?.length
                              ? supportSubdistributor[0]?.user?.phone
                              : ''
                            : application?.supportSubdistributor?.user.phone || '',
                        supportSubdistributorId:
                          application?.supportSubdistributor &&
                          !checkSupportLogin(
                            Number(auth.id),
                            Number(application?.supportSubdistributor?.user.id)
                          )
                            ? supportSubdistributorId
                            : application?.supportSubdistributorId,
                      });
                      setLoading(false);
                    } catch (e: unknown) {
                      setLoading(false);
                      console.error((e as Error).message);
                    }
                  }}
                  disabled={
                    application?.supportSubdistributor &&
                    checkSubDisDisable(
                      role,
                      Number(auth.id),
                      Number(application?.supportSubdistributor?.user.id)
                    )
                  }
                  searchFieldPlaceholder={'Search Distributor Sales RM'}
                />
              </GridItem>
              {/* <GridItem>
            <MFTextField
              name="subdistributorName"
              label="Distributor's RM Name *"
              placeholder="Enter Distributor name"
              disabled={true}
            />
          </GridItem> */}
              <GridItem>
                <MFTextField
                  name="subdistributorEmail"
                  label="Distributor Sales RM Email *"
                  placeholder="Enter Distributor email"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorPhone"
                  label="Distributor Sales RM Mobile No"
                  placeholder="Enter Distributor Sales RM Mobile No"
                  disabled={true}
                />
              </GridItem>
              {application?.supportSubdistributor?.user.id &&
                !checkSupportLogin(
                  Number(auth.id),
                  Number(application?.supportSubdistributor?.user.id)
                ) && (
                  <>
                    <GridItem>
                      <SearchableSelect
                        name="supportSubdistributorId"
                        label="CXO Name *"
                        items={selectSupport
                          ?.sort((support1, support2) =>
                            (support1.user['firstName'] || '')
                              ?.toString()
                              .localeCompare((support2.user['firstName'] || '').toString())
                          )
                          ?.map((item) => ({
                            key: item?.user?.firstName,
                            value: item?.id,
                          }))}
                        searchFieldPlaceholder={'Search CXO Name'}
                        disabled={true}
                      />
                    </GridItem>
                    <GridItem>
                      <MFTextField
                        name="supportDistributorEmail"
                        label="CXO Email *"
                        placeholder="Enter CXO Email"
                        disabled={true}
                      />
                    </GridItem>
                    <GridItem>
                      <MFTextField
                        name="supportDistributorPhone"
                        label="CXO Mobile No"
                        placeholder="Enter CXO Mobile No"
                        disabled={true}
                      />
                    </GridItem>
                  </>
                )}
            </>
          )}
          {/* <GridItem>
            <MFTextField
              name="distMangementFee"
              label=" Distribution/ Placement Fees"
              placeholder="Enter Distribution Commission"
              type="number"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="distPerformanceFee"
              label="Distribution Commission: Performance Fees"
              placeholder="Enter Distribution Commission"
              type="number"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
            />
          </GridItem> */}

          <GridItem>
            <MFTextField name="filledBy" label="Filled by" placeholder="Enter filled by" />
            <Typography
              component="span"
              sx={{ position: 'relative', left: 64, bottom: { xs: 85, md: 91 } }}>
              <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
            </Typography>
          </GridItem>
          <InfoDialog
            onClose={handleClose}
            open={open}
            content={'Please add the Name of the Subdistributor RM.'}
          />
          <AdditionalRMEMailID />
          {application &&
            application?.poaauthorisedsignatories?.length >= 0 &&
            checkValidationBasedOnDate(application.createdAt || '', poaValidationDate) &&
            checkIfApplicationIsIndividualPOA(application) &&
            POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE && (
              <>
                <SubHeading>Authorised Signatories</SubHeading>
                {/* <Typography
                  component="h3"
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: 25,
                    fontWeight: 500,
                    mb: { xs: 2, md: 3.5 },
                    color: 'secondary.main',
                  }}>
                  Authorised Signatories
                </Typography> */}
                <POAAuthorisedSignatoriesFragment
                  onChange={(e) => setAuthorisedSignatoriesPOA(e)}
                  values={authorisedSignatoriesPOA}
                  application={application}
                />
              </>
            )}
        </>
      ) : (
        <Grid
          xs={12}
          sm={12}
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: 'rgb(97, 209, 214)',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
            mt: { lg: 9, xs: 9 },
            mb: 2.9,
            ml: { xs: 3 },
          }}>
          No distributor mapped under this RM
        </Grid>
      )}
      <ConfirmationDialog
        message={`Are you sure you want to clear Distributor details ?`}
        open={openDialog}
        setOpen={handleDialogClose}
        onSave={() => {
          handleDialogClose();
          setValues({
            ...values,
            distributorName: '',
            distributorEmail: '',
            distributorNumber: '',
            distributorType: '',
            distributorId: null,
            subdistributorId: null,
            subdistributorName: '',
            subdistributorEmail: '',
            subdistributorPhone: '',
            supportSubdistributorId: null,
            supportDistributorEmail: '',
            supportDistributorPhone: '',
          });
          setSelectedDistributor([]);
        }}
        onCancel={handleDialogClose}
      />
    </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role } = useSelector((store: RootStateType) => store.auth);
  const [selectedDistributor, setSelectedDistributor] = useState<SubDistributor[]>([]);
  const [selectSupport, setSelectSupport] = useState<SupportRmProp[]>([]);
  const { auth } = useSelector((store: RootStateType) => store);

  const {
    distributor,
    rm,
    subdistributorId = null,
    subDistributor,
    distMangementFee = '',
    distPerformanceFee = '',
    filledBy = '',
    rmEmailId = '',
    rmMobile = '',
    rmName = '',
    rmEmail = '',
    supportSubdistributorId = null,
    supportSubdistributor,
  } = application || {};

  const {
    name,
    id,
    type,
    user: distributorUser,
  } = distributor || {
    arnCode: '',
    name: '',
    id: null,
    type: '',
  };

  const { email: distributorEmail = '', phone: distributorPhone = '' } = distributorUser || {};
  const {
    empCode,
    user: { email: RMEmail = '', firstName: RMFirstName = '', phone: RMPhone = '' },
  } = rm || { empCode: '', user: { email: '', phone: '' } };

  const {
    user: {
      firstName: subdistributorName = '',
      email: subdistributorEmail = '',
      phone: subdistributorPhone = '',
    } = {},
  } = subDistributor || {};

  const { user, id: supportId } = supportSubdistributor || {};

  const [authorisedSignatoriesPOA, setAuthorisedSignatoriesPOA] = useState<POAApplication>({
    authorisedSignatories: [],
    thrashold: 0,
  });

  const initialValues = useMemo<DistributorDetailsProps>(
    () => ({
      distributorId: id,
      distributorName: name,
      distributorType: type,
      distributorEmail: checkIfDistributorIndividual(type) ? distributorEmail : null,
      distributorNumber: checkIfDistributorIndividual(type) ? distributorPhone : null,
      loginType: [USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role)
        ? USER_ROLES.DISTRIBUTOR
        : USER_ROLES.RM,
      empCode,
      email: RMEmail,
      firstName: RMFirstName,
      mobile: RMPhone,
      subdistributorId: subdistributorId === null ? subdistributorId : Number(subdistributorId),
      subdistributorName,
      subdistributorEmail,
      distMangementFee,
      distPerformanceFee,
      subdistributorPhone,
      supportSubdistributorId:
        supportSubdistributorId === null
          ? supportSubdistributorId
          : Number(supportSubdistributorId),
      supportDistributorEmail: user?.email || '',
      supportDistributorPhone: user?.phone || '',
      filledBy,
      rmEmailId,
      rmMobile,
      rmName,
      rmEmail,
    }),
    [
      application?.id,
      id,
      name,
      type,
      distributorEmail,
      distributorPhone,
      role,
      empCode,
      RMEmail,
      RMFirstName,
      RMPhone,
      subdistributorId,
      subdistributorName,
      subdistributorEmail,
      distMangementFee,
      distPerformanceFee,
      subdistributorPhone,
      supportSubdistributorId,
      user,
      filledBy,
      rmEmailId,
      rmMobile,
      rmName,
      rmEmail,
    ]
  );

  useEffect(() => {
    setDistributors([]);
    setSelectedDistributor([]);
    setSelectSupport([]);

    setAuthorisedSignatoriesPOA({
      authorisedSignatories: [],
      thrashold: 0,
    });
    let isComponentActive = true;
    (async function () {
      try {
        if (!application?.id) return;

        if (Object.keys(application || {}).length && role === USER_ROLES.RM) {
          const res = (await dispatch(
            getDistributors({ isActive: true })
          )) as unknown as getDistributorsResponse;
          const { distributors = [] } = res || {};
          const updatedDistributor =
            application?.distributor_id && !application.distributor.isActive
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: [application.subDistributor].filter((ele) => ele),
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor = (
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find((distributor) => distributor.id === id)
                      ?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => distributor.id === id)
                    ?.subdistributors || []
            )
              .filter((ele) => ele)
              .filter(
                (ele) =>
                  subdistributorTypes[ele.subdistributorType || ''] === subdistributorTypes.direct
              );
            setSelectSupport([application?.supportSubdistributor as SupportRmProp]);
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);
          }
        } else if (
          application &&
          supportSubdistributor &&
          checkSupportLogin(Number(auth.id), supportSubdistributor?.user.id)
        ) {
          const { distributor, subDistributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectSupport([application?.supportSubdistributor as SupportRmProp]);
          const getDistributorRmDetails = (await dispatch(
            getDistributorRMbyId(Number(application?.supportSubdistributorId))
          )) as unknown as SubDistributorListType;
          setSelectedDistributor(
            getDistributorRmDetails?.directSubdistributorsDetails.directSubdistributors as any
          );
        } else {
          const { distributor, subDistributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectSupport([application?.supportSubdistributor as SupportRmProp]);
          setSelectedDistributor(
            subDistributor
              ? [{ ...subDistributor, id: Number(subDistributor.id) } as SubDistributor]
              : []
          );
        }
        setAuthorisedSignatoriesPOA({
          authorisedSignatories: application?.poaauthorisedsignatories || [],
          thrashold: application?.requiredAuthorisedSignatory || 0,
        });
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [application?.id]);

  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      const {
        distributorId,
        subdistributorId,
        distMangementFee = '0',
        distPerformanceFee = '0',
        filledBy,
        rmEmailId = '',
        rmMobile = '',
        rmName = '',
        rmEmail = '',
        supportSubdistributorId = null,
      } = values;
      const { id, applicant1ReferenceId, currentStep = null, status, hasPOA } = application || {};

      if (
        application &&
        checkValidationBasedOnDate(application.createdAt || '', poaValidationDate) &&
        checkIfApplicationIsIndividualPOA(application) &&
        POA_Authorized_signatory_can_Esign_Enable &&
        POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE
      ) {
        const getCanEsignCount = authorisedSignatoriesPOA.authorisedSignatories?.filter(
          (item) => item.canEsign
        );
        if (!authorisedSignatoriesPOA.authorisedSignatories?.length) {
          throw 'Please add Authorised Signatories';
        }
        if (!getCanEsignCount.length) {
          throw 'Please Select a member for E-Sign';
        }
        if (getCanEsignCount.length < authorisedSignatoriesPOA.thrashold) {
          throw 'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories';
        }
      }

      const Poa_can_esign =
        POA_Authorized_signatory_can_Esign_Enable &&
        POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE
          ? {
              poaauthorisedsignatories:
                application && checkIfApplicationIsIndividualPOA(application)
                  ? authorisedSignatoriesPOA.authorisedSignatories
                  : application?.poaauthorisedsignatories,
              requiredAuthorisedSignatory:
                application && checkIfApplicationIsIndividualPOA(application)
                  ? authorisedSignatoriesPOA.thrashold
                  : application?.requiredAuthorisedSignatory,
            }
          : {};

      const updatedApplication = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        ...Poa_can_esign,
        distributor_id: distributorId,
        subdistributorId: subdistributorId ? subdistributorId.toString() : subdistributorId,
        distMangementFee: distributorId ? distMangementFee : '0',
        distPerformanceFee: distributorId ? distPerformanceFee : '0',
        supportSubdistributorId: supportSubdistributorId
          ? supportSubdistributorId.toString()
          : supportSubdistributorId,
        filledBy: filledBy,
        rmEmailId: rmEmailId ? rmEmailId : null,
        rmMobile: rmMobile ? rmMobile : null,
        rmName: rmName ? rmName : null,
        rmEmail: rmEmail ? rmEmail : null,
        currentStep: currentStep === null ? 1 : currentStep,
      };
      const checkApplication = applicationComparison(application, updatedApplication);
      let restSchemePlan = {};
      const isDistributorExists =
        !distributorId &&
        application?.distributor_id &&
        (application?.schemeId || application?.planId);
      if (distributorId || isDistributorExists) {
        let getPlanId: any[] = [];
        if (Number(distributorId) !== Number(application?.distributor_id) && distributorId) {
          getPlanId = (
            (await dispatch(getDistributorById(distributorId))) as unknown as DistributorListType
          )?.planDetails.planIds;
        } else if (isDistributorExists) {
          (
            (await dispatch(getDirectApplicableFunds({ isActive: true }))) as unknown as FundProps[]
          )?.map((fund) => {
            getPlanId.push(
              ...fund.plans?.filter((fund) => fund.isApplicableForDirect)?.map((plan) => plan.id)
            );
            return fund;
          });
        }
        if (
          application?.planId &&
          !getPlanId.map((ele) => ele?.toString()).includes(application?.planId?.toString())
        ) {
          //reset whatEver Fields used in investmentPayment details section
          restSchemePlan = {
            planId: null,
            commitmentAmount: 0,
            setupFeePercentage: 0,
            managementFeesRate: 0,
            managementFeeAfterCommitment: 0,
            operatingExpenses: null,
            placementCost: 0,
            performanceFee: 0,
            hurdleRate: 0,
            contributionChequeAmount: 0,
            taxRate: 0,
            drawDownNumber: 0,
            setupFeeAmount: null,
            setupFeeGST: null,
            totalSetupFee: null,
            setupFeeTDS: null,
            netSetupFeeLessTDS: null,
            totalAmountPayable: null,
            excludeClause: '',
            exitCharge: '',
            distMangementFee: '0',
            distPerformanceFee: '0',
          };
        }
      }
      if (id && !checkApplication) {
        await dispatch(
          updateApplication({
            body: {
              ...updatedApplication,
              ...restSchemePlan,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status === 'sent_to_amc_approver' &&
                    hasPOA &&
                    USER_ROLES.SUBDISTRIBUTOR === role
                  ? 'draft'
                  : status,
              distMangementFee: distributorId ? distMangementFee : '0',
              distPerformanceFee: distributorId ? distPerformanceFee : '0',
              ...restSchemePlan,
              currentStep: 1,
              //currentStep === null ? 1 : currentStep
              filledBy,
            },
            applicationId: id,
          })
        );
        history.push('contributor-details', { id, applicant1ReferenceId });
      } else if (checkApplication) {
        history.push('contributor-details', { id, applicant1ReferenceId });
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      key={application?.id}
      initialValues={initialValues}
      validationSchema={distributorsValidationSchema(
        selectedDistributor,
        distributors,
        application?.createdAt || ''
      )}
      onSubmit={onSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Notes
            displayContent={
              'This section specifies whether the application is from an RM/Distributor’s RM.'
            }
          />
          <Grid container rowSpacing={2} columnSpacing={5}>
            {[USER_ROLES.RM].includes(role) && (
              <Grid item xs={12}>
                <UseRadioGroup
                  formLabel=""
                  name={`loginType`}
                  items={[
                    { label: 'RM', value: USER_ROLES.RM },
                    { label: 'Distributor', value: USER_ROLES.DISTRIBUTOR },
                  ]}
                />
              </Grid>
            )}
            {![USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR, USER_ROLES.POAAPPROVER].includes(
              role
            ) && values.loginType === USER_ROLES.RM ? (
              <RMDetail />
            ) : (
              <DistributorDetail
                distributors={distributors}
                values={values}
                selectedDistributor={selectedDistributor}
                selectSupport={selectSupport}
                setSelectSupport={setSelectSupport}
                setSelectedDistributor={(subdistributors) =>
                  setSelectedDistributor(subdistributors)
                }
                authorisedSignatoriesPOA={authorisedSignatoriesPOA}
                setAuthorisedSignatoriesPOA={(e) => setAuthorisedSignatoriesPOA(e)}
              />
            )}
          </Grid>
          <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 5 }}>
            <MFSubmitButton label="Next" />
          </Box>
        </Box>
      )}
    </Formik>
  );
}
